import { render } from "./delar.vue?vue&type=template&id=75055f8a"
import script from "./delar.vue?vue&type=script&lang=js"
export * from "./delar.vue?vue&type=script&lang=js"

import "./delar.vue?vue&type=style&index=0&id=75055f8a&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__